// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + "square-ai-chat" + "." + "da58b06b" + ".chunk.js";
};